import React, { useContext } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import Btn from 'components/Btn'
import { Menu } from 'assets/icons'
import { withTranslation } from 'react-i18next'
import { ClickAwayListener, Grid, MenuItem, TextField } from '@mui/material'
import { Transcontext } from 'pages/Transaction/context'
import { BsX, } from 'react-icons/bs'
import ReachAfrikaClickAway from './ReachAfrikaClickAway'

function HeaderFilterExport({ t, title, options = [] }) {
    const method = useForm({
        mode: 'all'
    })

    const { open, innerOpen, queryParameters, setOpen, setInnerOpen, setQueryParameters } = useContext(Transcontext)

    return (

        <div className="w-full flex justify-between p-3">
            <h3 className="text-xl font-semibold text-placeholder mb-5 lg:mb-0">{title}</h3>
            {/* <MTableToolbar  /> */}
            <div className="w-full lg:w-[fit-content] flex justify-between relative " >
                <div className=" order-2 gap-[10px] relative flex">
                    <TextField className='w-[290px]  ' placeholder='Search...' onChange={(e) => setQueryParameters({ ...queryParameters, search: e.target.value })}
                        inputProps={{
                            style: {
                                height: '40px',
                                padding: '0 20px'
                            }
                        }} />
                    <Btn
                        content={() => <Menu classList="h-5" />}
                        className={`w-10 h-10 border  rounded-lg ${open ? 'border-primary' : 'border-default'}`}
                        click={() => setOpen(!open)}
                        variant="outlined"
                    />
                </div>
                {
                    open ? (
                        <ul className={`shadow-lg top-12 border w-[180px] right-1 absolute z-30 bg-white divide-y rounded-lg shadow`}>
                            {
                                options.map(({ name, click, Content }, i) => {
                                    return (
                                        <div key={i}>
                                            {!innerOpen ? (
                                                <ClickAwayListener onClickAway={() => { setOpen(!open) }}>
                                                    <MenuItem onClick={() => setInnerOpen(click)} >
                                                        {name}
                                                    </MenuItem>
                                                </ClickAwayListener>) : null}
                                        </div>

                                    )
                                })
                            }
                            {
                                options.filter(option => option?.click === innerOpen).map(({ Content,name }) => {
                                    return (
                                        <ReachAfrikaClickAway onClickAway={() => { setOpen(!open); setInnerOpen('') }}>
                                            <FormProvider {...method} >
                                                <form className="w-[450px] rounded-md bg-white absolute -top-20 border h-[auto] right-0 z-[1000] " onSubmit={(e) => e.preventDefault()} name='filter'>
                                                    <div className="w-full flex px-3 py-2 bg-white ">
                                                        <label className="w-full font-bold grow block">{name} </label>
                                                        <BsX
                                                            className="w- text-secondary 6 h-6 "
                                                            color='black'
                                                            size={30}
                                                            onClick={() => setInnerOpen(false)}
                                                        />
                                                    </div>
                                                    <Grid container xs={11} className="justify-between mx-5 mx-auto px-4 bg-white mb-5 ">
                                                        <Content />
                                                    </Grid>
                                                </form>
                                            </FormProvider>
                                        </ReachAfrikaClickAway>
                                    )
                                })
                            }
                        </ul>
                    ) : (
                        null
                    )
                }
            </div>
        </div>
    )
}

export default withTranslation()(HeaderFilterExport)